import { useTranslation } from 'react-i18next'
import { UserTokensPage } from '../UserTokensPage'
import { TwoStepVerificationCard } from './TwoStepVerificationCard'

/**
 * The Security tab of the own profile (spec 2026-10-01-03): two-step
 * verification, then the caller's own sessions (spec 2026-10-01-01).
 */
export function UserSecurityPage({ org }: { org: string }) {
    const { t } = useTranslation('auth')
    return (
        <div className="space-y-6" data-testid="user-security-page">
            <TwoStepVerificationCard org={org} />
            {/* No uid: the caller's own sessions through /users/me/tokens,
                which needs no `contacts` permission (spec 2026-09-06-04). */}
            <UserTokensPage orgCode={org} tokenType="refresh_token" breadcrumbTitle={t('mfa.security.tab')} />
        </div>
    )
}
